<script lang="ts">
      import { onMount, tick, untrack } from 'svelte'
      import BlockWidth from '../blocks/BlockWidth.svelte'
      import { getBreakpointContext } from '../context/ts/BreakpointContext.svelte'
      import ImageElement from './ImageElement.svelte'
      import VideoElement from '../video/VideoElement.svelte'
      import BackdropVideoElement from '../video/BackdropVideoElement.svelte'
      import { renderTick } from '$lib/utils/flip'
      import { getLightroomContext } from './ts/Lightroom.svelte'

      function filterArrayByMultiple(array: any[], segments: number, nth: number) {
            const r = array.filter((i, index) => {
                  return (segments - index + nth) % segments == 0
            })
            return r
      }

      let { blocks, fixedAspect = 'none', columnWidth = 'wide', lastRowBumper = false } = $props()

      let lightroom = getLightroomContext()

      let shouldOpen = true
      let openTs = 0
      function blockOpen() {
        shouldOpen = false
      }

      async function openLightroom(ev: MouseEvent|TouchEvent) {
            if( ! shouldOpen ) {
              shouldOpen = true
              return
            }
            
            const target = ev.currentTarget as HTMLElement | undefined
            if (!target) return
            const _index = target.getAttribute('data-index')
            if (!_index) return
            const index = parseInt(_index)
            if (Number.isNaN(index)) return
            
            shouldOpen = false
            
            console.log("open", index, ev.type)
            lightroom.setContent(elements, index)

            const scroll = document.documentElement.scrollTop
            
            await renderTick()
            
            lightroom.open()
            await lightroom.waitForClose()
            render(gallery)
            await renderTick()
            document.documentElement.scrollTop = scroll
            shouldOpen = true
      }

      function sizeTable(breakpoint: number, width: 'string') {
            const normal = [
                  { breakpoint: -1, size: 1 },
                  { breakpoint: 1, size: 2 },
                  { breakpoint: 2, size: 3 },
                  { breakpoint: 4, size: 4 },
                  { breakpoint: 5, size: 5 },
            ]

            const wide = [
                  { breakpoint: -1, size: 1 },
                  { breakpoint: 1, size: 2 },
                  { breakpoint: 2, size: 2 },
                  { breakpoint: 4, size: 4 },
                  { breakpoint: 5, size: 4 },
            ]

            const widest = [
                  { breakpoint: -1, size: 1 },
                  { breakpoint: 1, size: 2 },
                  { breakpoint: 2, size: 2 },
                  { breakpoint: 4, size: 2 },
                  { breakpoint: 5, size: 2 },
            ]

            const sizes: {
                  [keyof: string]: {
                        breakpoint: number
                        size: number
                  }[]
            } = {
                  normal,
                  wide,
                  widest,
            }

            const size = sizes[width] ?? sizes['normal']
            let item = undefined
            for (let i = 0; i < size.length; i++) {
                  let b = size[i]
                  if (!item && b.breakpoint <= breakpoint) item = b
                  if (item && b.breakpoint > item.breakpoint && b.breakpoint <= breakpoint) item = b
            }
            const res = item ? item.size : 3

            return res
      }

      let breakpointContext = getBreakpointContext()
      let columns = $derived.by(() => {
            const val = breakpointContext.getBreakpointNumber()
            return sizeTable(val, columnWidth)
      })

      let elements = $derived.by(() => setupElements(blocks))

      let preload: HTMLDivElement
      let mosaic: HTMLDivElement

      let gallery: ReturnType<typeof setup> = $state([])

      async function normalizeColumns(gallery) {
            await renderTick()

            const heights: any[] = gallery.map((seg, ind) => {
                  return {
                        index: ind,
                        height: seg.element?.getBoundingClientRect().height ?? 0,
                  }
            })

            const pairs = []
            while (heights.length >= 2 ) {
                  const _heights = heights.map((h) => h.height)
                  const max = _heights.indexOf(Math.max(..._heights))
                  const min = _heights.indexOf(Math.min(..._heights))
                  pairs.push({ min: heights.splice(min, 1)[0], max: heights.splice(max, 1)[0] })
            }


            const res = pairs.map((pair) => compareColumns(gallery, pair))
            return res
      }

      function compareColumns(gallery, pair) {
            console.log(pair)
            const max = gallery[pair.max.index]
            const min = gallery[pair.min.index]
            const maxLastElement = max.blocks[max.blocks.length - 1]?.wrapper

            if (!min || !max) return false
            if (!maxLastElement || !min.element || !max.element ) return false

            const maxHeight = max.element.getBoundingClientRect().height
            const minHeight = min.element.getBoundingClientRect().height

            const maxLastElementHeight = maxLastElement.getBoundingClientRect().height

            if (maxHeight < minHeight + maxLastElementHeight) return false

            min.element.append(maxLastElement)

            return true
      }

      function setup(elements: ReturnType<typeof setupElements>, columns: number) {
            const mosaic = []
            for (let i = 0; i < columns; i++) {
                  const _blocks = filterArrayByMultiple(elements, columns, i).map((element) => ({
                        ...element,
                  }))

                  const seg = {
                        element: undefined as HTMLElement | undefined,
                        blocks: _blocks,
                  }
                  mosaic.push(seg)
            }

            return mosaic
      }

      async function addEventListeners(elements) {
            return elements.map( el => {
                  el.addEventListener("click", openLightroom)
            })
      }

      async function render(segments: ReturnType<typeof setup>) {
            await renderTick()
            if (!mosaic) return

            const start_height = preload.getBoundingClientRect().height
            segments.map((segment) => {
                  const parent = segment.element
                  return segment.blocks.map((block) => {
                        block.wrapper.innerHTML = ''
                        block.wrapper.append(block.element)
                        parent?.append(block.wrapper)
                  })
            })

            segments.forEach((seg) => seg.element?.classList.remove('after-render'))

            const norm = await normalizeColumns(segments)
            console.log(norm)
            segments.forEach((seg) => seg.element?.classList.add('after-render'))

            const end_height = mosaic.getBoundingClientRect().height

            mosaic.animate(
                  [
                        {
                              height: start_height + 'px',
                        },
                        {
                              height: end_height + 'px',
                        },
                  ],
                  {
                        duration: 0,
                        easing: 'ease-in-out',
                  }
            )
            //return await normalize()
      }

      function setupElements(blocks: any[]) {
            const _elements = blocks.map((el, i) => ({
                  index: i,
                  element: undefined as HTMLElement | undefined,
                  wrapper: undefined as HTMLElement | undefined,
                  item: el,
            }))

            return _elements
      }

      $effect(() => {
            columns
            blocks
            untrack(() => {
                  gallery = setup(elements, columns)
                  render(gallery)
            })
      })

      onMount(() => {
            //setTimeout( () => {
            //  gallery = setup(elements, columns)
            //  render(gallery)
            //}, 10000)
      })
</script>

<div bind:this={preload} class="grid prerender">
      {#each elements as block, i (i)}
            <button
                  data-index={block.index}
                  ontouchmove={blockOpen}
                  ontouchend={openLightroom}
                  onmouseup={openLightroom}
                  bind:this={block.wrapper}
                  class="mosaic-block relative block h-auto w-full float-start rounded-2xl shadow-md overflow-hidden"
                  style="aspect-ratio: {fixedAspect == 'none' ? 'unset' : fixedAspect}"
                  ><div bind:this={block.element} class="h-auto w-auto">
                        <!--<img bind:this={block.element} alt={block.item} src={block.item} class="w-full h-full object-cover" />-->
                        {#if block.item.mimeType.match(/image\/.*/)}
                              <ImageElement image={block.item} class="w-full object-cover {fixedAspect == 'none' ? 'h-full' : 'h-full'}"></ImageElement>
                        {/if}
                        {#if block.item.mimeType.match(/video\/.*/)}
                              <VideoElement video={block.item} class="w-full object-cover {fixedAspect == 'none' ? 'h-full' : 'h-full'}" autoplay={false} cache={false} muted={false}></VideoElement>
                        {/if}
                  </div>
            </button>
      {/each}
</div>

<div bind:this={mosaic} class="w-full h-auto flex mosaic gap-2 select-none">
      {#each gallery as segment, s (s)}
            <div bind:this={segment.element} class="mosaic-column {lastRowBumper ? 'bumper' : ''} w-full h-max min-h-0 flex-grow-0 flex gap-2 flex-col"></div>
      {/each}

      <!--{#each images as image, i (i)}
            {/each}-->
</div>



<style lang="postcss">
      @reference "tailwindcss/theme";

      .mosaic {
            /*grid-template-columns: repeat(3, 1fr);*/
            /*grid-auto-rows: auto;*/
      }

      .mosaic-column {
            @apply h-max;
      }

      .mosaic-column:global(.bumper) {
            @apply h-auto;
      }

      .mosaic-column:global(.after-render) {
            @apply h-auto;
      }

      .mosaic :global(.bumper) :global(.mosaic-block:last-child) {
            @apply flex-grow;
      }
      .mosaic :global(.bumper) :global(.mosaic-block:last-child > * ) {
            @apply h-full;
      }
</style>
